import vEmpty from './v-empty'
import vLoading from './v-loading'
import vClickOutside from './v-click-outside'

export default {
  empty: vEmpty,
  loading: vLoading,
  'click-outside': vClickOutside,
}